import { useSelector } from 'react-redux';

import { getWindowWidth } from '~/store/reducers/app/selectors';
import useSidebarStore from '~/store/useSidebarStore';

const DESKTOP_OPENED_LEFT_SIDEBAR_WIDTH = 323; // width of left sidebar with paddings and margins if opened
const DESKTOP_CLOSED_LEFT_SIDEBAR_WIDTH = 160; // width of left sidebar with paddings and margins if collapsed

export default function useBuilderBlockMaxWidth() {
  const windowWidth = useSelector(getWindowWidth);
  const { isDesktopSidebarOpen } = useSidebarStore();

  const desktopSidebarWidth = isDesktopSidebarOpen
    ? DESKTOP_OPENED_LEFT_SIDEBAR_WIDTH
    : DESKTOP_CLOSED_LEFT_SIDEBAR_WIDTH;

  // 278 - width of right preview
  // 10 - right padding of main content (with preview including)
  // 24 - gap between builder content and preview
  // 32 - paddings of Content (this component) container
  return windowWidth - 278 - 24 - 10 - desktopSidebarWidth - 32;
}
